import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import { gatewayUserInfoApi, type UserInfoResponse } from '../api/userinfo-api';

export const useGetUserInfoQuery = (
  options?: Omit<UseQueryOptions<UserInfoResponse>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['userinfo'],
    queryFn: () => gatewayUserInfoApi.getUserInfo(),
    ...options,
  });
};
